module.exports = __webpack_public_path__ + "img/people-surfing-illustration@2x.f54bbe03.png";